export type SortOrderTypes = '' | 'asc' | 'desc';

export enum NumberFilterOperator {
    Equals = 1,
    NotEqual = 2,
    LessThan = 3,
    LessThanOrEquals = 4,
    GreaterThan = 5,
    GreaterThanOrEquals = 6
  }